import {
	MapTo,
	withComponentMappingContext,
} from "@adobe/aem-react-editable-components";
import { Suspense, lazy } from "react";
import Spacer from "../Spacer/Spacer";
import { ModalProps } from "./Modal.types";

const Modal = lazy(() => import(/* webpackChunkName: 'modal' */ "./Modal"));

const ModalConfig = {
	emptyLabel: "Modal",
	isEmpty: function (props: ModalProps) {
		return !props.modalTitle;
	},
};
const ModalLoader = (props: ModalProps) => {
	return (
		<Suspense
			fallback={
				<Spacer
					mobile={"00"}
					tablet={"00"}
					desktop={"00"}
					isInEditor={false}
					cqPath={""}
				/>
			}
		>
			<Modal {...props} />
		</Suspense>
	);
};

MapTo<ModalProps>("alelo/components/content/v1/modal")(
	withComponentMappingContext(ModalLoader),
	ModalConfig
);
